export function buildTestRequest (test, source, endpointConfig) {
  let variables
  try {
    variables = JSON.parse(test.input)
  } catch (e) {
    throw new Error(`Invalid test input JSON: ${e.message}`)
  }

  let mockResponses = []
  try {
    const parsed = JSON.parse(test.responses)
    if (Array.isArray(parsed)) mockResponses = parsed
  } catch { /* empty or unparseable mocks treated as none */ }

  const strategy = test.testMode === 'unit' ? 'throwOnMiss' : 'liveOnMiss'

  return {
    source,
    variables,
    mocks: { responses: mockResponses, strategy },
    assertion: test.assertions || undefined,
    config: endpointConfig || undefined
  }
}

export function mapTestResponse (response, { hasAssertions = false } = {}) {
  const httpEvents = (response.events || []).filter(e => e.type === 'http')
  const logEvents = (response.events || []).filter(e => e.type === 'log')

  const assertionsPassed = !response.assertionError
  const pass = assertionsPassed && (!response.error || hasAssertions)

  return {
    pass,
    executionMs: response.executionMs || 0,
    result: response.result,
    error: response.error || null,
    assertionError: response.assertionError || null,
    requests: httpEvents.map(e => ({
      method: e.request?.method || 'GET',
      url: e.request?.url || '',
      status: e.response?.status || 0,
      durationMs: e.durationMs,
      mocked: !!e.mocked,
      requestBody: e.request?.body,
      responseBody: e.response?.body
    })),
    logs: logEvents.map(e => ({
      level: e.level || 'info',
      message: e.message || ''
    }))
  }
}
